import React, { useMemo, useState } from "react";

import { useTranslation } from "react-i18next";

import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import { SvgBlackTrash, SvgUpdateAssignationIcon } from "@routes/IconeSvg";
import { SvgSalaireInParcours } from "@routes/IconeSvg";

import calendar_carrer from "@assets/image/icones/carrer/calendar_carrer.svg";
import file_carrer from "@assets/image/icones/carrer/file_carrer.svg";
import Timer from "@image/icones/DocumentsEmployers/timer_v2.svg";

import AddButton from "@components/buttons/AddButton";
import { Menu } from "@components/tailwindComponents";

import { formatTextPeriod } from "@helpers/_functions";

import { ModalDuplicateSalary } from "../modals";
import SalaryForm from "./SalaryForm/index";
import SalaryItem from "./SalaryItem";

/** @type {typeof Tooltip} */
// @ts-ignore
const BlackTooltip = withStyles(() => ({
  tooltip: {
    maxWidth: "200px",
    backgroundColor: "#3F3F51",
    fontFamily: "Poppins_Medium",
    fontSize: "13px",
    padding: "8px 17px"
  }
}))(Tooltip);

/**
 *
 * @param {Object} props
 * @param {Object} props.career
 * @param {boolean} props.readOnly
 * @param {string} props.employeeId
 * @param {Object | null} props.employeePoste
 * @param {any[]} props.careerList
 * @param {() => void} props.onDelete
 * @param {() => void} props.onEdit
 * @returns
 */
export default function CareerItem(props) {
  const { t: translate, i18n } = useTranslation([
    "pages.employés.parcours&Certifications",
    "message"
  ]);

  const { career } = props;
  const [isCreatingSalary, setIsCreatingSalary] = useState(false);
  function handleAddSalary() {
    if (props.readOnly) return;
    setIsCreatingSalary(true);
  }

  const periodText = useMemo(() => {
    return formatTextPeriod({
      ...career,
      article1: translate("DU"),
      article2: translate("AU"),
      icon: calendar_carrer,
      language: i18n.language
    });
  }, [career?.dateStart, career?.endDate, career?.status, translate, i18n.language]);

  const listsMenu = [
    {
      icon: <SvgBlackTrash />,
      title: "Effacer",
      click: () => props.onDelete()
    },
    {
      icon: <SvgUpdateAssignationIcon />,
      title: "Modifier",
      click: () => props.onEdit()
    }
  ];

  // -- 🧩 Duplication management 🧩 --
  const [salaryToDuplicate, setSalaryToDuplicate] = useState(null);

  const toggleDuplicateSalaryModal = (salary = null) => {
    if (salary?._id) {
      setSalaryToDuplicate(salary);
      return;
    }

    setSalaryToDuplicate(null);
  };

  return (
    <>
      <tr className="arh-border-x-0 arh-border-t-0 arh-border-solid arh-border-borderTable hover:arh-bg-greyColor">
        <td className="arh-h-16 arh-pl-4 arh-align-middle">
          <div className="arh-whitespace-nowrap arh-border-0 arh-bg-transparent arh-text-left arh-font-poppins arh-text-xs arh-font-medium arh-text-darkGreyColor">
            <BlackTooltip
              placement="top"
              title={
                <p
                  className="arh-m-0 arh-w-full"
                  style={{
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 5,
                    fontSize: "12px"
                  }}
                >
                  {career.title}
                </p>
              }
            >
              <div className="arh-flex arh-items-center arh-gap-2">
                <img
                  alt="title course"
                  className="icones_timer GreenThemeSelect"
                  src={Timer}
                />
                <span className="arh-inline-block arh-max-w-[26rem] arh-overflow-hidden arh-text-ellipsis arh-whitespace-nowrap arh-font-poppins arh-text-fontBodyTable arh-font-medium arh-text-darkGreyColor desktop-middle:arh-max-w-[18rem]">
                  {career.title}
                </span>
              </div>
            </BlackTooltip>
          </div>
        </td>

        <td className="arh-h-16 arh-pr-[2%] arh-align-middle">
          <div className="arh-flex arh-items-center arh-gap-2 arh-text-xs arh-font-medium arh-text-darkGreyColor">
            {periodText}
          </div>
        </td>

        <td className="arh-h-16 arh-align-middle">
          <div className="arh-flex arh-h-full arh-items-center arh-justify-start">
            {career.note && (
              <BlackTooltip
                placement="top"
                title={
                  <p
                    className="arh-m-0 arh-w-full"
                    style={{
                      overflow: "hidden",
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 5,
                      fontSize: "12px"
                    }}
                  >
                    {career.note}
                  </p>
                }
              >
                <div className="arh-mr-4">
                  <img
                    alt="file_carrer"
                    src={file_carrer}
                  />
                </div>
              </BlackTooltip>
            )}
          </div>
        </td>

        <td className="arh-h-16 arh-align-middle">
          {career.description ? (
            <BlackTooltip
              placement="top"
              title={
                <p
                  className="arh-m-0 arh-w-full"
                  style={{
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 5,
                    fontSize: "12px"
                  }}
                >
                  {career.description}
                </p>
              }
            >
              <div className="arh-flex arh-items-center arh-justify-start">
                <img
                  alt="file_carrer"
                  src={file_carrer}
                />
              </div>
            </BlackTooltip>
          ) : (
            <span>-</span>
          )}
        </td>

        {!props.readOnly ? (
          <td className="arh-h-16 arh-align-middle">
            <div
              className="arh-mx-1 arh-flex arh-items-center arh-justify-center arh-text-center"
              onClick={(e) => e.stopPropagation()}
            >
              <Menu
                lists={listsMenu}
                withIcon
              />
            </div>
          </td>
        ) : (
          <td className="arh-h-16 arh-align-middle">&nbsp;</td>
        )}
      </tr>

      <tr className="arh-border-0">
        <td colSpan={8}>
          <div className="arh-mt-3 arh-w-full arh-overflow-hidden arh-rounded-lg arh-border arh-border-solid arh-border-[#DEE1E8]">
            {/* Header du bloc Échelons */}
            <div className="arh-flex arh-items-center arh-justify-between arh-border-[#E5E5E5] arh-bg-[#EBEEF3] arh-px-4 arh-py-2">
              <div className="arh-flex arh-items-center arh-gap-3">
                {SvgSalaireInParcours()}
                <span className="arh-whitespace-nowrap arh-text-xs arh-font-medium arh-text-darkColor">
                  {translate("Échelons, évolutions et avantages")}
                </span>
              </div>
              {!props.readOnly && (
                <AddButton
                  label={translate("Ajouter")}
                  onClick={handleAddSalary}
                  color="arh-bg-greenColor hover:arh-bg-darkGreenColor arh-border-none"
                  btnSize="arh-w-[30px] arh-h-[30px]"
                  iconPosition="right"
                />
              )}
            </div>

            {/* Liste des salaires et avantages */}
            <div className="arh-w-full arh-overflow-y-auto">
              <table className="arh-w-full arh-table-fixed arh-bg-greyColor">
                <colgroup>
                  <col className="arh-w-[28%]" />
                  <col className="arh-w-[27%]" />
                  <col className="arh-w-[13%]" />
                  <col className="arh-w-[27%]" />
                  <col className="arh-w-[5%]" />
                </colgroup>
                <tbody>
                  {career.salaries.map((salary, sIndex) => (
                    <SalaryItem
                      key={salary._id}
                      salary={salary}
                      status={Boolean(career.status)}
                      employeePoste={props.employeePoste}
                      career={career}
                      careerList={props.careerList}
                      readOnly={props.readOnly}
                      onDuplicate={() => toggleDuplicateSalaryModal(salary)}
                      otherSalaries={career.salaries.filter(
                        (s) => s._id !== salary._id
                      )}
                    />
                  ))}

                  {!props.readOnly && isCreatingSalary && (
                    <tr className="arh-bg-lightGreyColor">
                      <td
                        colSpan={5}
                        className="arh-p-4"
                      >
                        <div className="arh-w-full arh-rounded arh-border arh-border-solid arh-border-greyInput arh-bg-white arh-p-4">
                          <SalaryForm
                            isOpen={isCreatingSalary}
                            selectedSalary={null}
                            employeeId={props.employeeId}
                            employeePoste={props.employeePoste}
                            careerList={props.careerList}
                            onClose={() => setIsCreatingSalary(false)}
                            career={career}
                            readOnly={props.readOnly}
                            otherSalaries={career?.salaries}
                          />
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </td>
      </tr>

      <ModalDuplicateSalary
        isOpen={Boolean(salaryToDuplicate?._id)}
        selectedSalary={salaryToDuplicate}
        selectedCareer={career}
        employeeId={career.employeeId}
        onClickClose={toggleDuplicateSalaryModal}
      />
    </>
  );
}
